import {
  GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST,
  GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_SUCCESS,
  GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_FAILURE,
} from "./actionType";

// Reducer Ivoice Items

const initialState = {
  singleJobPageInvoiceItemsList: [],
};

export default function InvoiceItems(state = initialState, action) {
  switch (action.type) {
    case GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST:
      return {
        ...state,
        singleJobPageInvoiceItemsList: action.payload,
      };
    case GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_SUCCESS:
      return {
        ...state,
        singleJobPageInvoiceItemsList: action.payload,
      };
    case GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST_FAILURE:
      return {
        ...state,
        singleJobPageInvoiceItemsList: action.payload,
      };
    default:
      return state;
  }
}
